import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

interface BackLinkProps {
  /**
   * Target route path. Typed as a plain string so a caller can point it at any
   * list/record route and pass an arbitrary `search` bag (e.g. the originating
   * list's filters) without fighting per-route search-param typing.
   */
  to: string;
  /** Text after the arrow, e.g. "People". */
  label: string;
  params?: Record<string, string>;
  search?: Record<string, string>;
}

/**
 * The "← Back to X" link at the top of a detail page. Used for both the record
 * origin (return to a parent record) and the catalog fallback (return to the
 * originating filtered list).
 */
export function BackLink({ to, label, params, search }: BackLinkProps) {
  return (
    <Link
      to={to}
      params={params}
      search={search}
      className="inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
    >
      <ArrowLeft className="size-4" />
      {label}
    </Link>
  );
}
